import type { ComponentPropsWithoutRef, FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import type { ValidTypographyTags } from '../../types'
import { TypographyV2 } from '../Seatbelt2/Foundations/Typography'
import styles from './SectionHeader.module.scss'

export const SectionHeader: FunctionComponent<SectionHeaderProps> = ({
  className,
  text,
  tag = 'h2',
  ...rest
}) => {
  return text ? (
    <TypographyV2
      className={classnames(className, styles.sectionHeader)}
      tag={tag}
      textStyle="sb-text-body-default-strong"
      {...rest}
    >
      <TypographyV2
        className={styles.sectionHeaderText}
        textStyle="sb-text-body-default-strong"
        tag="span"
      >
        {text}
      </TypographyV2>
    </TypographyV2>
  ) : null
}

///////// IMPLEMENTATION /////////

export type SectionHeaderProps = {
  /**
   * Optional CSS class name that can be added to the typography element.
   */
  className?: string
  /**
   * Header text to be displayed
   */
  text: string
  /**
   * HTML tag to be used for typography. Defaults to h2.
   */
  tag?: ValidTypographyTags
} & ComponentPropsWithoutRef<ValidTypographyTags>
